import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import BotaoVoltar from "../components/BotaoVoltar";
import api from "../services/api";

export default function EditarPerfil() {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    api
      .get("/perfil/")
      .then((res) => {
        setForm(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Erro ao carregar perfil:", err);
        setLoading(false);
      });
  }, []);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleFile(e) {
    const file = e.target.files[0];
    if (file) {
      setForm({ ...form, foto_perfil: file });
      setPreviewUrl(URL.createObjectURL(file));
    }
  }

  async function salvar() {
    setSalvando(true);

    const fd = new FormData();

    if (form.nome !== undefined) {
      fd.append("nome", form.nome);
    }

    if (form.sobrenome !== undefined) {
      fd.append("sobrenome", form.sobrenome);
    }

    if (form.telefone !== undefined) {
      fd.append("telefone", form.telefone);
    }

    if (form.curso !== undefined) {
      fd.append("curso", form.curso);
    }

    if (form.foto_perfil instanceof File) {
      fd.append("foto_perfil", form.foto_perfil);
    }

    try {
      await api.patch("/perfil/", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Perfil atualizado com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar:", error);
      alert("Erro ao salvar o perfil. Verifique os dados.");
    }

    setSalvando(false);
  }

  if (loading) return <p>Carregando…</p>;

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="fw-bold mb-0">Editar Perfil</h2>
          <BotaoVoltar to="/dashboard" />
        </div>

        <div className="card p-3 shadow-sm">
          {/* NOME */}
          <label>Nome</label>
          <input
            name="nome"
            className="form-control mb-2"
            value={form.nome || ""}
            onChange={handleChange}
          />

          {/* SOBRENOME */}
          <label>Sobrenome</label>
          <input
            name="sobrenome"
            className="form-control mb-2"
            value={form.sobrenome || ""}
            onChange={handleChange}
          />

          {/* TELEFONE */}
          <label>Telefone</label>
          <input
            name="telefone"
            className="form-control mb-2"
            value={form.telefone || ""}
            onChange={handleChange}
          />

          {/* CURSO */}
          <label>Curso</label>
          <input
            name="curso"
            className="form-control mb-2"
            value={form.curso || ""}
            onChange={handleChange}
          />

          {/* FOTO */}
          <label>Foto de Perfil</label>

          {/* Preview da foto atual ou nova */}
          <div className="mb-3 text-center">
            <img
              src={
                previewUrl ||
                form.foto_perfil ||
                `https://ui-avatars.com/api/?name=${encodeURIComponent(form.nome || "Usuario")}&size=150&background=6366f1&color=fff&bold=true`
              }
              alt="Preview da foto de perfil"
              className="rounded-circle mb-2"
              style={{
                width: "150px",
                height: "150px",
                objectFit: "cover",
                border: "3px solid #6366f1",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(form.nome || "Usuario")}&size=150&background=6366f1&color=fff&bold=true`;
              }}
            />
          </div>

          <input
            type="file"
            accept="image/*"
            className="form-control mb-3"
            onChange={handleFile}
          />

          {/* BOTÃO SALVAR */}
          <button
            className="btn btn-primary"
            onClick={salvar}
            disabled={salvando}
          >
            {salvando ? "Salvando..." : "Salvar alterações"}
          </button>
        </div>
      </div>
    </>
  );
}
